import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminClients_municipalityIdData_importBatches = z.any()
export type TagsGetAdminClients_municipalityIdData_importBatches = z.infer<typeof tagsGetAdminClients_municipalityIdData_importBatches>

export const paramsGetAdminClients_municipalityIdData_importBatches = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetAdminClients_municipalityIdData_importBatches = z.infer<typeof paramsGetAdminClients_municipalityIdData_importBatches>

export const responseGetAdminClients_municipalityIdData_importBatches = z.object({ "payload": z.object({ "batches": z.array(z.object({ "id": z.string(), "kind": z.union([z.literal("readings"), z.literal("invoices")]), "filename": z.string(), "fileFormat": z.string(), "createdAt": z.string(), "createdBy": z.string(), "sourceHash": z.string(), "undoneAt": z.union([z.string(), z.null()]), "summary": z.object({ "rows": z.number().int(), "newRecords": z.number().int(), "duplicates": z.number().int(), "newBuildings": z.number().int(), "newCollectionPoints": z.number().int(), "errors": z.number().int() }) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminClients_municipalityIdData_importBatches = z.infer<typeof responseGetAdminClients_municipalityIdData_importBatches>

interface IGetAdminClients_municipalityIdData_importBatches extends BaseMethodType {
  tags: TagsGetAdminClients_municipalityIdData_importBatches,
  params: ParamsGetAdminClients_municipalityIdData_importBatches,
  response: ResponseGetAdminClients_municipalityIdData_importBatches
}
export const URL = '/admin/clients/:municipalityId/data-import/batches'
export const validation = {
  get: {
    tags: tagsGetAdminClients_municipalityIdData_importBatches,
    params: paramsGetAdminClients_municipalityIdData_importBatches,
    response: responseGetAdminClients_municipalityIdData_importBatches
  }
}
export interface AdminClients_municipalityIdData_importBatches extends BaseRouteType {
  get: IGetAdminClients_municipalityIdData_importBatches
}